module.exports = __webpack_public_path__ + "img/sidebar-4.3b7e38ed.jpg";